import * as i0 from '@angular/core';
import { inject, APP_ID, Injectable } from '@angular/core';
const counters = {};
class _IdGenerator {
  _appId = /*#__PURE__*/inject(APP_ID);
  static _infix = `a${ /*#__PURE__*/ /*#__PURE__*/Math.floor(/*#__PURE__*/Math.random() * 100000).toString()}`;
  getId(prefix, randomize = false) {
    if (this._appId !== 'ng') {
      prefix += this._appId;
    }
    if (!counters.hasOwnProperty(prefix)) {
      counters[prefix] = 0;
    }
    return `${prefix}${randomize ? _IdGenerator._infix + '-' : ''}${counters[prefix]++}`;
  }
  static ɵfac = function _IdGenerator_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || _IdGenerator)();
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: _IdGenerator,
    factory: _IdGenerator.ɵfac,
    providedIn: 'root'
  });
}
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
export { _IdGenerator };
